const deviceOutput = window.TCMS.viewtype;
const event = 'click';
const loginSelector = '.c24-fullpage-login-opener';
const loginLinkElement = document.querySelector(loginSelector);


const chattyRequestLoginListener  = (e) => {
    // it is always initialized with the open chat parameter in callback url
    Check24.login.init({
        api_product: window.TCMS.loginApiProduct,
        callback: window.TCMS.loginCallbackUrlOpenChat
});

    if (window.TCMS.env !== 'production') {
        Check24.login.config.env = 'test';
    }
};

//https://confluence.check24.de/display/HOULI/Full+Page+Login+-+Wireframe+Implementation
if (Check24.login) {
    Check24.login.init({
        api_product: window.TCMS.loginApiProduct,
        callback: window.TCMS.loginCallbackUrl
    });

    if (window.TCMS.env !== 'production') {
        Check24.login.config.env = 'test';
    }
}

// And add a listener for chattyRequestLogin event
// https://confluence.check24.de/spaces/HOCH/pages/1621819226/How+to+Full-Page+Login
window.document.addEventListener('chattyRequestLogin', chattyRequestLoginListener);

//this is important for wireframe user requests on test systems, default is www.check24.de
if (window.TCMS.env !== 'production') {
    //TODO FIX me
    //Check24.setHost('www.check24-test.de');
}

const eventListenerLogin = (e) => {
    e.preventDefault();

    if (window.TCMS.fullPageLoginUrl) {
        window.location.href = window.TCMS.fullPageLoginUrl;
    }
};

if (loginLinkElement) {
    loginLinkElement.addEventListener(event, eventListenerLogin, {
        once: false,
        passive: false,
        capture: true
    });
}
